__turbopack_context__.v({
  "submitIcon": "III8Tq_submitIcon",
});
